import { FormElement, FormElementKind } from '@gearbelt/global';

import {
  DateConfigLabels,
  DropdownConfigLabels,
  IssueSelectConfigLabels,
  TableColumnConfigLabel,
  TableConfigLabels,
  UnitReadingConfigLabels,
} from '@/components/form/config-field-labels';

export type ElementConfigLine = { label: string; value: string };

const bool = (value: boolean): string => (value ? 'true' : 'false');

// A read-only summary of an element's configuration for the revision-diff preview. It mirrors
// exactly the config the form designer exposes as editable controls (labels come from the shared
// `config-field-labels` registry) — nothing more. `required` is absent because the renderer already
// shows it as the "(required)" suffix; implicit/baked-in config (showTime, PassFail defaults, …) is
// absent because the designer never lets a user edit it. Kinds with no editable config return [].
export function getElementConfigSummary(element: FormElement): ElementConfigLine[] {
  switch (element.kind) {
    case FormElementKind.Date:
      // The designer only exposes the submission-date checkbox on date+time fields.
      return element.config.showTime ? [{ label: DateConfigLabels.isSubmissionDate, value: bool(element.config.isSubmissionDate) }] : [];
    case FormElementKind.IssueSelect:
      return [{ label: IssueSelectConfigLabels.requirePhotos, value: bool(element.config.requirePhotos) }];
    case FormElementKind.UnitReading:
      return [
        { label: UnitReadingConfigLabels.unitId, value: element.config.unitId },
        { label: UnitReadingConfigLabels.allowLowerReading, value: bool(element.config.allowLowerReading) },
      ];
    case FormElementKind.Dropdown:
      if (element.config.source === 'static') {
        return [
          { label: DropdownConfigLabels.source, value: DropdownConfigLabels.sourceStatic },
          { label: DropdownConfigLabels.options, value: element.config.options.join(', ') },
        ];
      }
      return [
        { label: DropdownConfigLabels.source, value: DropdownConfigLabels.sourceList },
        { label: DropdownConfigLabels.listId, value: element.config.listId },
      ];
    case FormElementKind.Table:
      return [
        {
          label: TableConfigLabels.columns,
          value: element.config.columns.map((column) => `${column.label} (${TableColumnConfigLabel[column.kind]})`).join(', '),
        },
      ];
    default:
      return [];
  }
}
